const route = [
    {//个性化学习
        //subject：21小学  22初中
        path: '/personaLearning',
        component: function (resolve) {
            require(['VIEWS/personaLearning/index.vue'], resolve);
        }
    },
    //试题错误详情
    {
        path: '/personaLearning/taskDetail',
        component: function (resolve) {
            require(['VIEWS/personaLearning/taskdetail.vue'], resolve);
        }
    },
    //知识点掌握率详情  
    {
        path: '/personaLearning/knowledgDetail',
        component: function (resolve) {
            require(['VIEWS/personaLearning/knowledgDetail.vue'], resolve);
        }
    },
    //按学生查看详情  
    {
        path: '/personaLearning/stuDetail',
        component: function (resolve) {
            require(['VIEWS/personaLearning/stuDetail.vue'], resolve);
        }
    },
    //个性化学习分享页面  
    {
        path: '/personaLearning/share',
        component: function (resolve) {
            require(['VIEWS/personaLearning/share.vue'], resolve);
        }
    },
    //个性化学习微信首页广告  
    {
        path: '/personaLearning/ad',
        component: function (resolve) {
            require(['VIEWS/personaLearning/ad.vue'], resolve);
        }
    }
];
export default route
